<div style="padding-top: 5%;">
  <mat-spinner class="center" *ngIf="loading"></mat-spinner>
  <div *ngIf="!loading">
    <input type="text" class="form-control" placeholder="filter" namd="fullName" [(ngModel)]="filter">

    <table class="table table-striped" >
      <thead>
        <tr>
          <th [appSort]="students" data-order="desc" data-name="schoolYear">Year</th>
          <th [appSort]="students" data-order="desc" data-name="gradeCode">Grade</th>
          <th [appSort]="students" data-order="desc" data-name="location">School</th>
          <th [appSort]="students" data-order="desc" data-name="studentId">StudentId</th>
          <th [appSort]="students" data-order="desc" data-name="fullName">Name</th>

          <!-- <th [appSort]="students" data-order="desc" data-name="unexcusedAbsence">Unexcused Abs</th>
          <th [appSort]="students" data-order="desc" data-name="excusedAbsence">Excused Abs</th> -->
          <th [appSort]="students" data-order="desc" data-name="absentCount">Total Abs</th>
          <th [appSort]="students" data-order="desc" data-name="totalDays">Days Enrolled</th>
          <th >Att Percentage</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let s of students | tableFilter: filter">
          <td>{{s.schoolYear}}</td>
          <td>{{s.gradeCode}}</td>
          <td>{{s.location}}</td>
          <td>{{s.studentId}}</td>
          <td>{{s.fullName}}</td>

          <!-- <td>{{s.unexcusedAbsence}}</td>
          <td>{{s.excusedAbsence}}</td> -->
          <td>{{s.absentCount}}</td>
          <td>{{s.totalDays}}</td>
          <td>{{(100-(s.absentCount/s.totalDays)*100 )|  number : '1.2-2'}}%</td>
          <td>
            <!-- <button type="button" class="btn btn-primary"  value="">Open Detail</button> -->
            <fa-icon (click)="viewDetail(s)" [icon]="faInfoCircle" title="More student information" style=" cursor: pointer; color: #002D62;" class="fa-2x"></fa-icon>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

